import { render, staticRenderFns } from "./swiper_bar.vue?vue&type=template&id=7884d17b&scoped=true&"
import script from "./swiper_bar.vue?vue&type=script&lang=js&"
export * from "./swiper_bar.vue?vue&type=script&lang=js&"
import style0 from "./swiper_bar.vue?vue&type=style&index=0&id=7884d17b&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7884d17b",
  null
  
)

export default component.exports